import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";
import HelperAvailability from "utils/helper/HelperAvailability";
import { bookingConstants } from "utils/constants/booking-constants";
import { constantsActive } from 'utils/constants/constants'

export default class ObjectFloor {
	
	static defaults = {
		available_for: HelperAvailability.AVAILABLE_FOR_EVERYONE,
		aed: constantsActive.NO,
		active: constantsActive.YES,
	}
	
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.FLOORS );
	}
	
	/**
	 *
	 * @param guid
	 * @returns {unknown}
	 */
	static first = ( guid ) => {
		return _.first(
			this.get([ { guid: guid } ])
		);
	}
	
	static filter = ( objects ) => {
		return _.filter( ObjectClass.filterActive( objects ), object => {
			return HelperAvailability.isAvailable( bookingConstants.FLOOR, object );
		})
	}
	
	/**
	 * Sort teh bookings by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static order = ( objects ) => {
		return _.orderBy( objects, 'position', 'asc' )
	}
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
}
